import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import LogoMits from "./../../../assets/images/logomits.png";
import { Button } from "@mui/material";
import { SideMenu } from "./../../components";
import { useNavigate } from "react-router-dom";
let InvoicePreview = () => {
  const navigate = useNavigate();
  return (
    <SideMenu>
      <div className="page-container">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid item xl={8} lg={8} md={8} sm={12} xs={12}></Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() =>
                  navigate("/invoice/create", {
                    state: { type: "edit" },
                  })
                }
              >
                <p className="page-header-button-text">Edit</p>
              </Button>
            </Grid>
            <Grid item xl={2} lg={2} md={2} sm={12} xs={12}>
              <Button
                className="header-button"
                variant="text"
                onClick={() => navigate("/invoice")}
              >
                <p className="page-header-button-text">Save & Continue</p>
              </Button>
            </Grid>
          </Grid>
          <br />
          <div className="invoice-preview-data">
            <p className="data-view-heading">Student monthly fee</p>
            <div className="data-view-header-location-main">
              <p className="data-view-header-location">Tax invoice</p>
            </div>
            <div className="invoice-preview-red-line" />
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <p className="invoice-details-heading">
                  Student name:{" "}
                  <span className="invoice-details-des">Willow Anderson</span>
                </p>
                <br />
                <p className="invoice-details-heading">Discription</p>
                <p className="invoice-details-des">
                  Duis odio neque, pretium a massa eget, consectetur venenatis
                  nisl. In sollicitudin tempus quam, quis dignissim ex eleifend
                  eu.
                </p>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={12} xs={12}>
                <p className="invoice-account-details">Invoice ID:0123456789</p>
                <p className="invoice-account-details">Order Number:89</p>
                <p className="invoice-account-details">
                  Invoice date:08/04/2022
                </p>
                <p className="invoice-account-details">
                  Payment due:08/05/2022
                </p>
              </Grid>
            </Grid>
            <br />
            <br />
            <br />
            <div className="table-data-container">
              <table className="create-invoice-table">
                <tr className="invoice-preview-table-heading-tr">
                  <th className="create-invoice-table-title-heading">Title</th>
                  <th className="create-invoice-table-date-heading">
                    Start date - End date
                  </th>
                  <th className="create-invoice-table-rate-heading">Rate</th>
                  <th className="create-invoice-table-tax-heading">Tax</th>
                  <th className="create-invoice-table-amount-heading">
                    Amount
                  </th>
                </tr>
                <tr>
                  <td className="create-invoice-table-monthly-fees">
                    Monthly student Fee
                  </td>
                  <td className="create-invoice-table-data">
                    08/03/2022 - 08/04/2022
                  </td>
                  <td className="create-invoice-table-data">1099</td>
                  <td className="create-invoice-table-data">
                    Service tax (5%)(5%)
                  </td>
                  <td className="create-invoice-table-data">1099</td>
                </tr>
                <tr>
                  <td
                    className="create-invoice-table-payment-main"
                    rowSpan={4}
                  ></td>
                  <td className="create-invoice-table-sub-heading">
                    Sub Totle
                  </td>
                  <td className="create-invoice-table-empty"></td>
                  <td className="create-invoice-table-empty"></td>
                  <td className="create-invoice-table-price">1099</td>
                </tr>
                <tr>
                  <td className="create-invoice-table-sub-heading">Discount</td>
                  <td className="create-invoice-table-empty" colSpan={2}></td>
                  <td className="create-invoice-table-price">-10</td>
                </tr>
                <tr>
                  <td className="create-invoice-table-sub-heading">
                    Service Tax (5%)
                  </td>
                  <td className="create-invoice-table-empty"></td>
                  <td className="create-invoice-table-empty"></td>
                  <td className="create-invoice-table-price">119.65</td>
                </tr>
                <tr>
                  <td
                    className="create-invoice-table-total-heading"
                    style={{ backgroundColor: "#BC2026", color: "#fff" }}
                  >
                    Total
                  </td>
                  <td
                    className="create-invoice-table-empty"
                    style={{ backgroundColor: "#BC2026", color: "#fff" }}
                  ></td>
                  <td
                    className="create-invoice-table-empty"
                    style={{ backgroundColor: "#BC2026" }}
                  ></td>
                  <td
                    className="create-invoice-table-total-price"
                    style={{ backgroundColor: "#BC2026", color: "#fff" }}
                  >
                    1208.65
                  </td>
                </tr>
              </table>
            </div>
            <p className="invoice-note-heading">Default Notes / terms</p>
            <p className="invoice-note-list">
              Duis odio neque, pretium a massa eget, consectetur venenatis nisl.
              In sollicitudin tempus quam, quis dignissim ex eleifend eu.
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas.
            </p>
            <p className="invoice-note-list">Bank details : Rak Bank</p>
            <p className="invoice-note-list">AC/ name : lorem impusum</p>
            <p className="invoice-note-list">AC/ No : 1234567890123</p>
            <p className="invoice-note-list">IBN no : BPN77 000 00</p>
            <p className="invoice-note-list">Swift code : BUNKARATMN</p>
            <p className="invoice-footer-heading">
              Thanks for learning with us
            </p>
            <br />
            <Grid container spacing={2}>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <img src={LogoMits} className="invoice-footer-logo" />
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <p className="invoice-footer-sub-heading">Gmits tech</p>
                <p className="invoice-footer-title">David anderson</p>
                <p className="invoice-footer-title">united arab emirates</p>
              </Grid>
              <Grid item xl={4} lg={4} md={6} sm={6} xs={12}>
                <p className="invoice-footer-sub-heading">
                  Contact information
                </p>
                <p className="invoice-footer-title">Mobile: +971 1234567890</p>
                <p className="invoice-footer-title">gmitstech.com</p>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </SideMenu>
  );
};
export default InvoicePreview;
